import React from 'react';
import { Row } from 'react-bootstrap';

export const FactsContainer = ({ children }) => (
	<section className="fun-facts-section">
		<div className="auto-container">

			<Row className="clearfix">
				{children}
			</Row>

		</div>
	</section>
);



// WEBPACK FOOTER //
// ./src/components/ui/Facts/FactsContainer.js